<!-- page wrapper -->
<div class="file-preview-wrapper session-espired-container">
    <!-- <mat-card> -->
        <!-- title -->
        <!-- <mat-card-title id="wrapper">
            <div>
                <mat-icon class="file-preview-header-icon">
                    description
                </mat-icon>
                <span class="status-dialog-title">File Preview</span>
            </div>
            <mat-icon class="material-icons dialog-close-icon" matTooltip="Close" (click)="onCancel()">
                close
            </mat-icon>
        </mat-card-title> -->
        <div class="title-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
            <!-- <mat-icon class="file-preview-header-icon">
                description
            </mat-icon> -->
            <div class="zip-title" cdkFocusInitial>File Preview</div>
            <button mat-button class="toolbar-icon-button" (click)="onCancel()">
                <mat-icon class="material-icons dialog-closeicon">
                    close
                </mat-icon>
            </button>
        </div>
        <!-- pdf - resume -->
        <!-- <mat-card-content> -->
            <!-- <pdf-viewer [src]="src"  [show-all]="true" [original-size]="true" [zoom-scale]="'page-fit'"></pdf-viewer> -->

                <pdf-viewer [src]="src" [rotation]="0" [original-size]="true" [show-all]="true"
                  [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false"
                  [render-text]="true" [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false"
                  style="width: 100%; height: 100%;"></pdf-viewer>
        <!-- </mat-card-content> --> 
    <!-- </mat-card> -->
</div>